// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__t5VM2","iconBtn":"styles_iconBtn__23yXO","closeBtn":"styles_closeBtn__7ZqtQ","disabled":"styles_disabled__nWdkt"};